import { render, staticRenderFns } from "./PropertyText.vue?vue&type=template&id=6782358c&"
import script from "./PropertyText.vue?vue&type=script&lang=js&"
export * from "./PropertyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6782358c')) {
      api.createRecord('6782358c', component.options)
    } else {
      api.reload('6782358c', component.options)
    }
    module.hot.accept("./PropertyText.vue?vue&type=template&id=6782358c&", function () {
      api.rerender('6782358c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertyText.vue"
export default component.exports